import { useParams } from "react-router-dom"
import { Button,Col,Card,Input,Label,FormGroup,Form, Dropdown, DropdownToggle,DropdownItem,DropdownMenu} from "reactstrap";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import {useForm} from "react-hook-form";
import { useState,useEffect } from "react";
import ApiService from "../../../services/apiService";
import {toast} from "react-toastify";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { updateSchemeTitle, schemeTitle } from "../../../constants";
import Update from "../../table/Update";
const UpdateSchemeVillage = () => {
    
  const {register,handleSubmit,setValue,formState:{errors}} = useForm();
  const {Id} = useParams();
  const navigate = useNavigate();
  const [distributaryZone,setDistributaryZone] = useState([]);
  const [ data,setData] = useState<any>([])
  
  const initialData = {
            
       Scheme_Village : data?.scheme_Village,
       Distributary_Zone: data?.distributary_Zone, // match label field
       DistributaryZoneId: data?.distributaryZoneId, // match id field
  }
 
  useEffect(() => {
    const fetchSchemeVillage = async () => {
       try{
         const response = await ApiService.axiosApi(`/schemeVillage/${Id}`,{
            method: 'GET',
         });
         if(response.success){
         
          setData(response.data)
            
         }
       }catch(error: any){
        toast.error(error.message);
       }
    }
    if(Id) fetchSchemeVillage();
  }, [Id, setValue, navigate]);

    useEffect(() => { 
      
      const fetchDistributaryZone = async () => {
        try{
        const response = await ApiService.axiosApi('/dzone',{
          method: 'GET',
          params:{
            pageNumber :0,
            pageSize:0
       }
        });
        if(response.success){
          setDistributaryZone(response.data.data);
        }else{
          toast.error(response.message);
        }
      
      }catch(error: any){
        toast.error(error.message);
      }
    
    }
          fetchDistributaryZone();
    }, [])

    const onSubmit = async (data :any) => {
      try{
      
        const response = await ApiService.axiosApi(`/schemevillage/${Id}`,{
          method: 'PUT',
          data: data,
        })
        if(response.success){
          toast.success("Scheme/Village updated successfully");
          navigate("/scheme-village-list");
        }else{
          toast.error(response.message);
        }
          
      }catch(error: any){
        toast.error(error.message);
      }
    }

    
    

    return (
        <>
         <Update
           title={updateSchemeTitle}
           parentTitle = {schemeTitle}

           fields={
             [
                {
                  name:"Scheme_Village",
                  label : "Scheme_Village",
                  type : "text"
                },
                {
                  name: "Distributary_Zone",
                  label: "Distributary Zone", 
                  isDropdown:true,
                  dropdownData:distributaryZone,
                  dropdownLabel:"distributary_Zone",
                  idFieldName:"DistributaryZoneId"
                }
             ]
           }
           onSubmit={onSubmit}
           initialData ={initialData}
         />
    </>
    )
}

export default UpdateSchemeVillage;
